import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container text-center">
        <p>Powered by Clorian</p>
      </div>
    </footer>
  );
};

export default Footer;
